export type DictionaryAvailabilityGridTranslation = {
  available: string;
  counters: {
    label: string;
    legend: string;
    short: string;
  };
  dayHint: {
    tentativeOverWindow: string;
    windowOnlyBlocked: string;
    windowOnlyFree: string;
  };
  hintDetails: string;
  item: string;
  legend: {
    windowOnly: {
      assembly: string;
      event: string;
    };
  };
  reservation: {
    eventRange: string;
    occupied: string;
    statusShort: {
      confirmed: string;
      tentative: string;
    };
    windowRange: string;
  };
  status: {
    confirmed: string;
    free: string;
    tentative: string;
    windowOnly: string;
  };
  tableAriaLabel: string;
  weekday: {
    0: string;
    1: string;
    2: string;
    3: string;
    4: string;
    5: string;
    6: string;
  };
};

export const dictionaryAvailabilityGridTranslation: DictionaryAvailabilityGridTranslation = {
  available: 'Dostępne',
  counters: {
    label: 'Rezerwacje innych ofert: potwierdzone {{confirmed}}, wstępne {{tentative}}',
    legend:
      'Potw. i wst. to rezerwacje potwierdzone i wstępne innych ofert, których okno zasobu sięga w dany dzień.',
    short: '{{confirmed}} potw. / {{tentative}} wst.',
  },
  dayHint: {
    tentativeOverWindow:
      'Rezerwacja wstępna; dzień zajmuje też potwierdzony montaż lub demontaż innej oferty. Nie można tu wybrać terminu imprezy.',
    windowOnlyBlocked:
      'Tylko montaż lub demontaż innej oferty. Dzień jest zajęty dla terminu imprezy.',
    windowOnlyFree:
      'Tylko montaż lub demontaż innej oferty. Dzień jest wolny dla montażu i demontażu.',
  },
  hintDetails: 'Najedź na kropkę rezerwacji, aby zobaczyć szczegóły.',
  item: 'Element słownika',
  legend: {
    windowOnly: {
      assembly: 'Tylko montaż lub demontaż (wolny dla montażu i demontażu)',
      event: 'Tylko montaż lub demontaż (zajęty dla imprezy)',
    },
  },
  reservation: {
    eventRange: 'Impreza',
    occupied: 'Zajęty',
    statusShort: {
      confirmed: 'Potwierdzona',
      tentative: 'Wstępna',
    },
    windowRange: 'Okno zasobu',
  },
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny',
    tentative: 'Rezerwacja wstępna',
    windowOnly: 'Tylko montaż lub demontaż',
  },
  tableAriaLabel: 'Porównanie dostępności',
  weekday: {
    0: 'Nd',
    1: 'Pn',
    2: 'Wt',
    3: 'Śr',
    4: 'Czw',
    5: 'Pt',
    6: 'Sb',
  },
};
